import RealEstateRecord from '#calculator/financialRecords/RealEstateRecord'
import type { TimelineRecord } from '#calculator/timeline/TimelineRecord'
import type { TaxCalculationResult } from '#calculator/types'
import { TaxKey, type TaxMetadata } from '#dictionary'
import { getRateForRegionYear } from '#dictionary/realEstateRates'
import type { Region } from '#dictionary/regions'
import { TAX_BY_KEY } from '#dictionary/taxes'

// TODO: @max State Property Tax per state calculation is even wrth with growth rate
class RealEstateTax {
  public readonly metadata: TaxMetadata = TAX_BY_KEY.get(
    TaxKey.TaxStateProperty
  )!

  public calculate(
    timelineRecord: TimelineRecord,
    year: number
  ): TaxCalculationResult {
    const financialRecord = timelineRecord.financialRecord
    if (!financialRecord) {
      throw new Error(
        `Financial record not found for timeline record ${timelineRecord.id}`
      )
    }

    const region = financialRecord.region
    const realEstateTaxRate =
      financialRecord instanceof RealEstateRecord
        ? financialRecord.realEstateTaxRate
        : null
    const taxRate =
      realEstateTaxRate ?? this.getTaxRateForRegionAndYear(region, year)

    return {
      description: `${this.metadata.name} on "${financialRecord.name}" (${region})`,
      taxMetadata: this.metadata,
      amount: timelineRecord.value * taxRate,
      taxableIncome: timelineRecord.value,
      standardDeduction: 0,
      effectiveRate: taxRate,
      totalTax: timelineRecord.value * taxRate,
      bracketBreakdown: [],
    }
  }

  private getTaxRateForRegionAndYear(region: Region, year: number): number {
    return getRateForRegionYear(region, year)?.taxRate ?? 0
  }
}

export default RealEstateTax
